import React from 'react';

const DashboardPage = () => {

  return (
    <div>
      メニューを選択して下さい
    </div>
  );
};

export default DashboardPage;



// WEBPACK FOOTER //
// ./src/containers/DashboardPage.js